<template>
  <div class="setting">
    <div class="currentRoute">
      <div class="route">
        <router-link to="/knowledgebase">知识库</router-link>
      </div>
      <p>/设置</p>
    </div>
    <form @submit="onSubmit">

      <label for="kbImage">上传知识库图片:</label>
      <input type="file" id="kbImage" @change="uploadImage" accept="image/*">

      <label for="kbDescription">知识库描述:</label>
      <textarea id="kbDescription" v-model="kbDescription"></textarea>

      <div v-show="titleSeparator == 'h0'" style="margin-top: 20px;display: flex;flex-direction: column;">
        <label for="tokenRange">*分割Token数:</label>
        <div>
          <input type="range" id="tokenRange" min=10 max=1000 v-model="tokenCount">
          <span><input type="number" v-model="tokenCount"></span>
        </div>
        <div v-show="!ifMarkdown" style="display: flex;flex-direction: column;">
          <label for="segmentIdentifier">*分段标识符(多个分隔符用逗号分隔开):</label>
          <input type="text" id="segmentIdentifier" v-model="segmentIdentifier">
        </div>

        <label for="tokenRange">*重叠token数:</label>
        <div>
          <input type="range" id="tokenRange" min=10 max=1000 v-model="overlap">
          <span><input type="number" v-model="overlap"></span>
        </div>
        <label for="ifMarkdown">按markdown格式拆分:</label>
        <div>
          <input type="radio" id="ifMarkdown" value="true" v-model="ifMarkdown"> <label for="ifMarkdown">是</label>
          <input type="radio" id="ifMarkdown" value="false" v-model="ifMarkdown"> <label for="ifMarkdown">否</label>
        </div>
        <label for="ifOCR">是否使用OCR模式</label>
        <div>
          <input type="radio" id="ifOCR" value="true" v-model="ifOCR"> <label for="ifOCR">是</label>
          <input type="radio" id="ifOCR" value="false" v-model="ifOCR"> <label for="ifOCR">否</label>
        </div>

      </div>

      <!-- 加一个单选框，可选择二级标题、三级标题、四级标题 -->
      <label>是否按标题分割:</label>
      <div>
        <input type="radio" id="h0" value="h0" v-model="titleSeparator"> <label for="h0">无需按标题</label>
        <input type="radio" id="h2" value="h2" v-model="titleSeparator"> <label for="h2">二级标题</label>
        <input type="radio" id="h3" value="h3" v-model="titleSeparator"> <label for="h3">三级标题</label>
        <input type="radio" id="h4" value="h4" v-model="titleSeparator"> <label for="h4">四级标题</label>
      </div>

      <button type="submit" style="margin-top: 20px;width=80px;height: 30px;">保存</button>
    </form>
  </div>
</template>

<script>
import { getkbConfig, writekbConfig } from '../../api/auth';
export default {
  data() {
    return {
      kbName: '',
      kbDescription: '',
      permission: 'onlyMe',
      tokenCount: 100,
      imgBase64: '',
      segmentIdentifier: '\n',
      overlap: 0,
      titleSeparator: 'h0',
      ifMarkdown: false, // 是否使用Markdown
      ifOCR: false, // 是否使用OCR模式
    }
  },
  props: {
    folderName: {
      type: String,
      required: true
    },
    currentUserId: {
      type: String,
      required: true
    }


  },
  mounted() {
    // 初始化数据
    this.kbName = this.folderName;
    console.log('当前文件夹：', this.kbName);
    getkbConfig(this.currentUserId, this.kbName).then((res) => {
      console.log('获取知识库配置文件', res);
      this.kbDescription = res.data.config.detail;
      this.imgBase64 = res.data.config.imgBase64;
      this.tokenCount = parseInt(res.data.config.splitToken);
      this.segmentIdentifier = res.data.config.segmentIdentifier;
      this.overlap = parseInt(res.data.config.overlap);
      this.titleSeparator = res.data.config.titleSeparator;
      this.ifMarkdown = this.stringToBool(res.data.config.ifMarkdown);
      this.ifOCR = this.stringToBool(res.data.config.ifOCR);
    })
  },
  methods: {
    stringToBool(str) {
      return str === 'true';
    },
    uploadImage(event) {
      {
        // 处理上传图片逻辑
        const file = event.target.files[0];
        if (file) {
          // 检查文件大小是否超过2M
          if (file.size > 2 * 1024 * 1024) {
            alert('图片大小不得超过2M');
            return;
          }

          // 创建FileReader对象
          const reader = new FileReader();
          reader.onload = (e) => {
            this.imgBase64 = e.target.result; // 将Base64编码的图片存储到data中
            console.log('上传图片Base64编码:', this.imgBase64);
          };
          reader.readAsDataURL(file); // 将文件读取为Data URL
        }
      }
    },
    onSubmit(event) {
      // 处理提交逻辑
      event.preventDefault();
      if (this.overlap > this.tokenCount) {
        alert('重叠token数不能大于分割token数');
        return;
      }
      else {
        writekbConfig(
        this.currentUserId, 
        this.kbName,
        this.imgBase64, 
        this.kbDescription,  
        this.tokenCount,
        this.segmentIdentifier,
        this.overlap,
        this.titleSeparator,
        this.ifMarkdown,
        this.ifOCR
        ).then(() => {
          console.log('保存知识库配置文件');
          alert('保存成功');
        })
      }
    }
  }
}
</script>
<style scoped>
.setting {
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.currentRoute {
  display: flex;
  font-size: 20px;
  font-size: 24px;
  margin-bottom: 15px;
}

.route :hover {
  color: #187EFF;
}

form {
  display: flex;
  flex-direction: column;
  max-width: 600px;
  margin: 20px auto;
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;
}

form label {
  margin-top: 10px;
}

form input[type="text"],
form input[type="number"],
form textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

form textarea {
  min-height: 100px;
  resize: vertical;
}

form input[type="range"] {
  flex: 1;
  min-width: 100px;
}

form button[type="submit"] {
  margin-top: 20px;
  width: 100%;
  max-width: 200px;
  height: 40px;
  background-color: #187EFF;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

form button[type="submit"]:hover {
  background-color: #1565c0;
}

/* 移动端响应式样式 */
@media screen and (max-width: 768px) {
  .setting {
    padding: 5px;
  }

  .currentRoute {
    position: relative;
    top: auto;
    left: auto;
    font-size: 18px;
  }

  form {
    margin: 10px auto;
    padding: 0 10px;
  }

  form label {
    font-size: 14px;
  }

  form input[type="file"] {
    width: 100%;
    font-size: 14px;
  }

  form div {
    flex-wrap: wrap;
    gap: 10px;
  }

  form input[type="radio"] {
    margin-right: 5px;
  }

  form button[type="submit"] {
    width: 100%;
    max-width: none;
  }
}
</style>
